export class ChartStrategy {
  constructor(props) {
    this.props = props;
    this.commonProps = {
      data: props.normalizedData,
      margin: { top: 20, right: 15, bottom: 10, left: 0 },
      animationDuration: 800,
      animationEasing: "ease-out",
    };
    this.axisProps = {
      stroke: props.axisColor,
      tick: { fill: props.axisColor, fontSize: 12 },
    };
  }
}
